(() => {
  const bar = document.querySelector('[data-ishva-sticky-atc]');
  if (!bar) return;

  const mainButton = document.querySelector('[id^="ProductSubmitButton-"]');
  const mainForm = mainButton?.closest('form[action*="/cart/add"]');
  const mainVariant = mainForm?.querySelector('input[name="id"]');
  const stickyVariant = bar.querySelector('[data-ishva-variant-id]');
  const stickyButton = bar.querySelector('[data-ishva-button]');
  const stickyPrice = bar.querySelector('[data-ishva-price]');
  const priceContainer = document.querySelector('[id^="price-"]');

  if (!mainButton || !mainForm || !mainVariant || !stickyVariant || !stickyButton) return;

  const sync = () => {
    stickyVariant.value = mainVariant.value;
    stickyButton.disabled = mainButton.disabled;
    const label = stickyButton.querySelector('span');
    if (label) {
      label.textContent = mainButton.disabled
        ? stickyButton.dataset.ishvaSoldOutLabel
        : stickyButton.dataset.ishvaAvailableLabel;
    }
    const mainPrice = priceContainer?.querySelector('.price');
    if (mainPrice && stickyPrice) {
      const currentPrice = mainPrice.classList.contains('price--on-sale')
        ? mainPrice.querySelector('.price__sale .price-item--sale')
        : mainPrice.querySelector('.price__regular .price-item--regular');
      if (currentPrice) stickyPrice.textContent = currentPrice.textContent.trim();
    }
  };

  const setVisibility = () => {
    const visible = mainButton.getBoundingClientRect().bottom < 0;
    bar.classList.toggle('is-visible', visible);
    document.body.classList.toggle('ishva-sticky-visible', visible);
  };

  new MutationObserver(sync).observe(mainButton, { attributes: true, childList: true, subtree: true });
  mainForm.addEventListener('change', () => setTimeout(sync, 0));
  if (priceContainer) new MutationObserver(sync).observe(priceContainer, { childList: true, subtree: true });
  addEventListener('scroll', setVisibility, { passive: true });
  addEventListener('resize', setVisibility, { passive: true });
  sync();
  setVisibility();
})();
